@if(selectedDeviceTime){
<app-device-connection-details (closeSignal)="selectedDeviceTime=undefined" [id]="selectedDeviceTime.id!">
</app-device-connection-details>
}
<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
            <div class="col-md-8 ps-5">
                <h2 class="col pb-2 title">
                    {{ "MONITORING_DEVICECONNECTION" | translate }}
                </h2>
                <h6 class="col subtitle">{{ "DEVICECOLLECTIONSUBTITLE" | translate }}</h6>
            </div>
            <div class="col-md-4 d-flex justify-content-end align-items-center pe-5">
                @if (
                authService.isAuthorized([PermissionsEnum.Systemmonitoring_deviceconnectiontime_download])
                ) {
                    <button class="col-auto add justify-content-center" (click)="download()">
                      {{ "DOWNLOAD" | translate }}
                    </button>
                }
            </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2">
                <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
                <div class="datepicker-container-wrapper position-relative">
                    <div class="button-wrapper pe-2">
                        <div class="button">
                            <img alt="Date" src="assets/core/table-button/date.svg" />
                            <div class="button-text" (click)="toggleModal()"
                                [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                                <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                                    {{ selectedDate }}
                                </ng-container>
                                <ng-template #noDateSelected>
                                    <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                                </ng-template>
                            </div>
                            <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit"
                                src="assets/device/x.svg" (click)="clearDates()" />
                        </div>
                    </div>
                    @if (isDatepickerOpen) {
                    <div class="overlay" (click)="toggleModal()"></div>
                    <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                        [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
                    }
                </div>
                <app-search placeholder="{{ 'SCHEDULED_DATA_SEARCHBY' | translate }}"
                    (searchChange)="searchChange($event)"></app-search>
                <div class="button-wrapper-gray m-2">
                    <div class="button" (click)="reloadTable()" title="Reload table">
                        <div><img alt="Refresh" src="assets/device/refresh.svg" /></div>
                    </div>
                </div>
            </div>
            <div class="row g-0 m-0 pt-3">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "ENERGYREGISTERS_METERNO" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DEVICESETUP_METERMAKE" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "SESSIONSTATUS" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DATEINSTALLED" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "LATESTCONN" | translate }}</span>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of data" (click)="handleRowClick(row)">
                            <td appIsNew [executedTime]="row.latestConnection!" [seconds]="dayInMs"></td>
                            <td>
                                <span (click)="clipboardService.copyToClipboard(row.meterNumber!, $event)"
                                    class="copyable">
                                    {{ row.meterNumber }}
                                    <span class="copy-tooltip"
                                        *ngIf="clipboardService.copiedText === row.meterNumber">{{"COPIED" |
                                        translate}}</span>
                                </span>
                            </td>
                            <td>
                                <span>{{row.meterMake}}</span>
                            </td>
                            <td>
                                <span class="text-wrapper"
                                    [ngClass]="row.sessionStatus ? 'status-completed' : 'status-failed'">{{row.sessionStatus
                                    ? "On": "Off"}}</span>
                            </td>
                            <td>
                                <span>{{ row.installationDate ? (row.installationDate | date: 'd MMMM yyyy') : '/'
                                    }}</span>
                            </td>
                            <td>
                                <span>{{ row.latestConnection ? (row.latestConnection | date: 'd MMMM yyyy, HH:mm') :
                                    '/' }}</span>
                            </td>
                            <td>
                                @if(authService.isAuthorized([PermissionsEnum.Device_view])){
                                <span class="icon-wrapper"
                                    [class.rotating]="row.meterNumber && commandStatusDict[row.meterNumber]?.status === CommandStatus.Pending"
                                    [class.failed]="row.meterNumber && commandStatusDict[row.meterNumber]?.status === CommandStatus.Failed"
                                    (click)="retryCommand(row, $event)" [attr.title]="row.meterNumber && commandStatusDict[row.meterNumber]?.status === CommandStatus.Failed
                                        ? getErrorMessage(row.meterNumber) : null">
                                    <svg-icon alt="Sync" class="hover-effect" [src]="row.meterNumber
                                               ? (commandStatusDict[row.meterNumber]?.status === CommandStatus.Pending
                                                  ? 'assets/syncing.svg'
                                                  : 'assets/sync.svg')
                                               : 'assets/sync.svg'">
                                    </svg-icon>
                                </span>
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfItems" [pageSize]="pageSize"
            [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
    </div>
</div>
